<template>
  <div id="paginaCedolini">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Cedolini</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropStagioni' ref='dropStagioni' :query='queryStagioni' :dataSource='stagioniData'
                  :index='stagioniIndex' :fields='stagioniFields' :change='onStagioneChange'
                  v-model="stagioneCorrente"
                  placeholder='Seleziona un Anno'></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropSpettacoli" ref="dropSpettacoli" :query="querySpettacoli"
                  :dataSource="elencoSpettacoliList" :index="spettacoliIndex" :fields="elencoSpettacoliFields"
                  :enabled="dropSpettacoliEnabled" :change="onSpettacoloChange"
                  v-model="spettacoloCorrente" :allowFiltering="true"
                  :filtering="spettacoloFiltering"
                  placeholder="Seleziona uno Spettacolo"
                ></ejs-dropdownlist>
              </b-col>
              <!-- TODO: dropdown dei mesi -->
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropMese" ref="dropMese"
                  :dataSource="elencoMesi" :index="mesiIndex" :fields="elencoMesiFields"
                  :enabled="dropMesiEnabled" :change="onMeseChange"
                  v-model="meseCorrente"
                  placeholder="Seleziona un mese"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">

                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="scrittureFullData" :allowSorting="true"
                    :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                    :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                    >
                    <e-columns>
                      <e-column field="id" headerText="Id" width="10" :isPrimaryKey="true" :visible="false"></e-column>
                      <e-column
                        field="soggetto" headerText="Cognome" width="50"
                        foreignKeyField="id" foreignKeyValue="cognome" :dataSource="this.elencoSoggFiltratiList"
                      ></e-column>
                      <e-column
                        field="soggetto" headerText="Nome" width="40"
                        foreignKeyField="id" foreignKeyValue="nome" :dataSource="this.elencoSoggFiltratiList"
                      ></e-column>
                      <e-column field="ruoloGenerale" headerText="Ruolo" width="50"></e-column>
                      <e-column field="tipoCedolino" headerText="Tipologia" width="80"></e-column>
                      <e-column field="statoCedolini" headerText="Stato" width="40"></e-column>
                      <e-column field="nota" headerText="Nota" width="80"></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

    <!-- dialogA1: dialogDettaglioCedolini ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA1" ref="dialogA1" :header="dialogA1.header" :buttons="dialogA1.buttons"
      :visible="dialogA1.visible" :showCloseIcon="dialogA1.showCloseIcon" :close="dialogA1Close" :open="dialogA1Open"
      :zIndex="dialogA1.zIndex" :animationSettings="dialogA1.animationSettings">
      <!-- Content dialog -->
      <b-alert :show="dialogA1ErrorMsg.length > 0" variant="danger" class="mt-1 mx-1 text-center" dismissible @dismissed="dialogA1ErrorMsg = []">
        <p v-for="(msg, i) in dialogA1ErrorMsg" :key="i" class="mb-0" style="font-size: 1.1rem;">{{ msg }}</p>
      </b-alert>
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Cedolini">

          <b-row class="match-height">

            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Cedolino</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                    </template>
                    <b-dropdown-item href="#">
                      ...
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia Cedolino</label>
                      <ejs-dropdownlist id="tipologia" name="tipo" ref="tipologia" v-model="cedolinoActiveData.tipologia"
                        :dataSource="tipoCedolinoList" :fields="tipoCedolinoFields" placeholder="Tipologia Cedolino"
                        />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="empty1" class="h5"
                        > </label
                      >
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                      <label for="mansione" class="h5">Mansione</label>
                      <ejs-textbox
                        id="mansione"
                        name="mansione"
                        v-model="cedolinoActiveData.mansione"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="categoriaInps" class="h5">Categoria Inps</label>
                      <ejs-textbox
                        id="categoriaInps"
                        name="categoriaInps"
                        v-model="cedolinoActiveData.categoriaInps"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.regimeFiscale  -->
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="regimeFiscale" class="h5">Regime Fiscale</label>
                      <ejs-dropdownlist
                        id="regimeFiscale"
                        ref="regimeFiscale"
                        v-model="cedolinoActiveData.regimeFiscale"
                        :dataSource="regimeFiscaleList"
                        :fields="labelValFields"
                        placeholder="Regime Fiscale"
                      />
                    </b-col>
                    
                    <b-col xl="6" md="12" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="categoriaEnpals" class="h5">Categoria Enpals</label>
                      <ejs-dropdownlist
                        id="categoriaEnpals"
                        v-model="cedolinoActiveData.categoriaEnpals"
                        :dataSource="categoriaEnpalsList"
                        :fields="labelValFields"
                        placeholder="Categoria Enpals"
                      />
                    </b-col>
                    
                    <b-col xl="6" md="6" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="numGiorniMeseRetribuiti" class="h5"
                        >Numero giorni del mese retribuiti</label
                      >
                      <ejs-numerictextbox
                        id="numGiorniMeseRetribuiti"
                        v-model="cedolinoActiveData.numGiorniMeseRetribuiti"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero giorni del mese retribuiti"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :change="onnumGiorniMeseRetribuitiChange"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="numGiorniScritturaTotali" class="h5"
                        >Numero giorni totali di scrittura retribuiti</label
                      >
                      <ejs-numerictextbox
                        id="numGiorniScritturaTotali"
                        v-model="cedolinoActiveData.numGiorniScritturaTotali"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero giorni totali di scrittura retribuiti"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="dal" class="h5">Dal</label>
                      <ejs-datepicker
                        id="dal"
                        ref="dpDal"
                        v-model="cedolinoActiveData.dal"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="al" class="h5">Al</label>
                      <ejs-datepicker
                        id="al"
                        ref="dpAl"
                        v-model="cedolinoActiveData.al"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                    
                    <b-col xl="6" md="12" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="retribGiornaliera" class="h5"
                        >Retribuzione Giornaliera</label
                      >
                      <ejs-numerictextbox
                        id="retribGiornaliera"
                        v-model="cedolinoActiveData.retribGiornaliera"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Retribuzione Giornaliera"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="compensoTotale" class="h5"
                        >Compenso Totale Scrittura</label
                      >
                      <ejs-numerictextbox
                        id="compensoTotale"
                        v-model="cedolinoActiveData.compensoTotale"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Compenso Totale Scrittura"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="compenso" class="h5"
                        >Compenso del Mese Corrente</label
                      >
                      <ejs-numerictextbox
                        id="compenso"
                        v-model="cedolinoActiveData.compenso"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Compenso"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="rimborsiSpese" class="h5"
                        >Rimborsi Spese</label
                      >
                      <ejs-numerictextbox
                        id="rimborsiSpese"
                        v-model="cedolinoActiveData.rimborsiSpese"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="rimborsiSpese"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>
                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.assogRimbSpese  -->
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="assogRimbSpese" class="h5">Assoggettamento Rimborso Spese</label>
                      <ejs-dropdownlist
                        id="assogRimbSpese"
                        v-model="cedolinoActiveData.assogRimbSpese"
                        :dataSource="assogRimbSpeseList"
                        :fields="labelValFields"
                        placeholder="Assoggettamento Rimborso Spese"
                      />
                    </b-col>
                    
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="ritenutaAcconto" class="h5"
                        >Ritenuta d'acconto</label
                      >
                      <ejs-numerictextbox
                        id="ritenutaAcconto"
                        v-model="cedolinoActiveData.ritenutaAcconto"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Ritenuta d'acconto"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>


                    <b-col xl="6" md="12" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="empty1" class="h5"
                        > </label
                      >
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="aliquotaIva" class="h5">Aliquota IVA</label>
                      <ejs-dropdownlist
                        id="aliquotaIva"
                        ref="aliquotaIva"
                        v-model="cedolinoActiveData.aliquotaIva"
                        :dataSource="aliquotaIvaList"
                        :fields="labelValFields"
                        placeholder="Aliquota IVA"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="iva" class="h5"
                        >IVA</label
                      >
                      <ejs-numerictextbox
                        id="iva"
                        v-model="cedolinoActiveData.iva"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="IVA"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="EnpalsFPL" class="h5"
                        >Enpals F.P.L.</label
                      >
                      <ejs-numerictextbox
                        id="EnpalsFPL"
                        v-model="cedolinoActiveData.EnpalsFPL"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="EnpalsFPL"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="EnpalsContrSolid" class="h5"
                        >Enpals Contributo Solidarietà</label
                      >
                      <ejs-numerictextbox
                        id="EnpalsContrSolid"
                        v-model="cedolinoActiveData.EnpalsContrSolid"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Enpals Contributo Solidarietà"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2" v-show="this.cedolinoActiveData.tipologia==1">
                      <label for="EnpalsContrAgg" class="h5"
                        >Enpals Contributo Aggiuntivo</label
                      >
                      <ejs-numerictextbox
                        id="EnpalsContrAgg"
                        v-model="cedolinoActiveData.EnpalsContrAgg"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Enpals Contributo Aggiuntivo "
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="false"
                      />
                    </b-col>

                    
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="nota" class="h5">Annotazione</label>
                      <ejs-textbox
                        id="nota"
                        name="annotazione"
                        v-model="cedolinoActiveData.nota"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="text-right mt-1">
                      <ejs-button id="calcolaCedolinoButton" cssClass="e-flat"
                        @click.native="calcolaCedolino()">Calcola il cedolino</ejs-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, LinkPlugin, AlertPlugin, ProgressPlugin,
  ToastPlugin, SpinnerPlugin,
} from 'bootstrap-vue'
// import Vuexy
// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import {
  DatePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import { Query } from '@syncfusion/ej2-data'
import {
  TextBoxPlugin, NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Aggregate,Group ,ForeignKey, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";

const axios = require('axios')
// use bootstrap-vue
Vue.use(LayoutPlugin)
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(DatePickerPlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(DropDownListPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ButtonPlugin)
enableRipple(true)
// api
const apiSoggettiUrl = "/demo/api/soggetto";
const apiSpettacoloUrl = '/demo/api/spettacolo'
const apiCedolinoUrl = '/demo/api/cedolino'
const apiScritturaRicercaUrl = "/demo/api/scrittura/ricerca";

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {
  },
  data() {
    return {
      loading: false,
      // per gestione stagioni
      stagioniData: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      stagioniFields: { value: "val", text: "label" },
      stagioniIndex: -1,
      queryStagioni: null,
      stagioneCorrente: null,
      // per gestione spettacoli
      elencoSpettacoliList: [],
      elencoSpettacoliFields: { value: "id", text: "titolo" },
      elencoMesi: [],
      dizionarioMesi: {
        1: "Gennaio",
        2: "Febbraio",
        3: "Marzo",
        4: "Aprile",
        5: "Maggio",
        6: "Giugno",
        7: "Luglio",
        8: "Agosto",
        9: "Settembre",
        10: "Ottobre",
        11: "Novembre",
        12: "Dicembre",
      },
      spettacoliMese: {},
      elencoMesiFields: { value: "val", text: "label"},
      spettacoliIndex: -1,
      mesiIndex: -1,
      dropSpettacoliEnabled: false,
      dropMesiEnabled: false,
      querySpettacoli: null,
      spettacoloCorrente: null,
      meseCorrente: null,
      showDownload: false,
      // lista valori assogRimbSpese
      assogRimbSpeseList: [
        { label: "Si", val: "Si" },
        { label: "No", val: "No" },
      ],
      aliquotaIvaList: [
        { label: "10%", val: "10" },
        { label: "22%", val: "22" },
      ],
      regimeFiscaleList: [
        // elenco di xxx
        { label: "Non Specificato", val: "nonSpecificato" },
        { label: "Italiano Ordinario", val: "ordinario" },
        { label: "Italiano Forfettario", val: "forfettario" },
        { label: "Italiano Occasionale", val: "occasionale" },
        { label: "Straniero", val: "straniero" },
      ],
      categoriaEnpalsList: [
        { label: "Tab C - Lavoratori iscritti dopo il 31/12/95", val: "tabC" },
        {
          label: "Tab D - Autonomi già iscritti al 31/12/95 Ex 1° gruppo",
          val: "tabD",
        },
        {
          label: "Tab G - Dipendenti già iscritti al 31/12/95 Ex 2° gruppo",
          val: "tabG",
        },
        {
          label:
            "Tab R - Ballerini e Tersicorei, coreografi e assistenti coreografi",
          val: "tabR",
        },
        { label: "Sconosciuta", val: "sconosciuta" },
      ],
      // struttura etichetta - valore per dropdown
      labelValFields: { value: "val", text: "label" },
      // gestione elementi nascosti
      nonMostrare: false,
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 15,
        firstDayOfWeek: 1,
        minMoneyNumber: 0,
        minDayInteger: 0,
        maxDayInteger: 100,
        stepDayInteger: 1,
        firstDayOfWeek: 1,
      },
      scrittureFullData: [], // elenco filtrato scritture dello spettacolo
      scrittureOriginalData: [],
      ricevuteFullData: [], // elenco completo ricevute
      cedolinoActiveId: 0, // Id cedolino attivo (0 se nuovo)
      cedolinoActiveData: {}, // dati completi del cedolino
      scritturaActiveData: {}, // dati della scrittura selezionata
      soggettoActiveData: {}, // dati del soggetto interessato dalla scrittura
      operazione: 'show',
      // elenco soggetti
      elencoSoggFiltratiList: [],

      tipoCedolinoMap: {
        '1': 'Ordinario',
        '2': 'Diritti',
      },
      // elenco tipo cedolini
      tipoCedolinoList: [
        { label: 'Ordinario', id: '1' },
        { label: 'Diritti', id: '2' },
      ],
      tipoCedolinoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista dei ruoli


      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1ErrorMsg: [],
      dialogA1: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogA1Ok, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogA1Cancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Genera', tooltipText: 'Genera Cedolino', prefixIcon: 'e-expand', id: 'edit',
          },
          // {
          //   text: 'Mostra', tooltipText: 'Mostra Cedolino', prefixIcon: 'e-expand', id: 'show',
          // },
          {
            text: 'Download XLSX', tooltipText: 'Download XLSX Cedolino', prefixIcon: 'e-expand', id: 'download',
          },
          {
            text: 'Download PDF', tooltipText: 'Download PDF Cedolino', prefixIcon: 'e-expand', id: 'downloadPDF',
          },
          {
            text: 'Cancella', tooltipText: 'Cancella Cedolino', prefixIcon: 'e-delete', id: 'delete',
          },
          'Search',
        ],
      },
    }
  },
  created() {
    // log
    console.log('Pagina Cedolini Creata')
    // inizializzazione elenchi dal backend
    // chiamate API

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem('userData') !== null) {
      console.log('Recupero elenchi dal backend')
      useJwt.get(apiSpettacoloUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN")
          alert("Effettua di nuovo il login")
        } else {
          // console.log("Elenco Spettacoli");
          // console.log(d.data);
          this.elencoSpettacoliList = d.data;
        }
      });

    // soggetti filtrati (artisti e tecnici)
    useJwt.get(apiSoggettiUrl).then((d) => {
      // console.log("Elenco soggetti anagrafica");
      // console.log(d.data);
      this.elencoSoggFiltratiList = d.data;
      // filtro in base a isArtista o isTecnico
      const results = this.elencoSoggFiltratiList.filter((obj) => {
        return obj.isArtista === true || obj.isTecnico === true;
      });
      // console.log("Elenco Soggetti Filtrati");
      // console.log(results);
      this.elencoSoggFiltratiList = results;
    });

    // elenco ricevute
    useJwt.get(apiCedolinoUrl).then((d) => {
      if (d.status != 200) {
        console.log("REDIRIGERE A LOGIN")
        alert("Effettua di nuovo il login")
      } else {
        // console.log("Elenco ricevute");
        // console.log(d.data);
        this.ricevuteFullData = d.data;
      }
    });

    } else {
      console.log('Non trovo UserData, prova ancora')
    }

  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn()
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Group, Aggregate],
  },
  methods: {
    roundNumber: function(val) {
      return Math.round(val * 100) / 100;
    },
    // porta a 0 i campi di cedolinoActiveData assenti, nulli o stringa vuota
    impostaDefaultNumerico: function(campi) {
      campi.forEach((campo) => {
        const val = this.cedolinoActiveData[campo]
        if (val === null || val === undefined || val === '') {
          this.cedolinoActiveData[campo] = 0
        }
      })
    },
    spettacoloFiltering: function (e) {
      var searchData = this.elencoSpettacoliList;
      var query = this.querySpettacoli.clone();
      if (e.text != "") {
        query = query.where("titolo", "contains", e.text, true);
      }
      e.updateData(searchData, query);
    },
    dataMinMax: function(stringa, val, op) {
      if (stringa) {
        const d = new Date(stringa)
        const m = d.getMonth() + 1
        if (op === 'min') {
          if (m < val) {
            return m;
          }
        } else {
          if (m > val) {
            return m;
          }
        }
      }
      return val;
    },
    // crea mappa tra mesi dell'anno e id scritture del mese
    mappaSpettacoloMese: function(prop, id_scrittura, d) {
      if (prop) {
        const data = new Date(prop)
        const m = data.getMonth() + 1
        if (!d[m]) { // crea array se non esiste
          d[m] = new Set()
        }
        d[m].add(id_scrittura)
      }
    },
    gestioneGiorniMese: function() {
      let count = 0
      if (this.scritturaActiveData.dettGiorniScrittura) {
        this.scritturaActiveData.dettGiorniScrittura.forEach((obj) => {
          const d = new Date(obj);
          // ricorda che i mesi partono da zero
          if (this.meseCorrente == (d.getMonth() + 1)) {
            count += 1
          }
        });
        this.cedolinoActiveData.numGiorniMeseRetribuiti = count
      }
    },
    // per dropdownlist combinate
    onStagioneChange: function (e) {
      var spettacoliObj = document.getElementById('dropSpettacoli').ej2_instances[0];
      var meseObj = document.getElementById('dropMese').ej2_instances[0];
      spettacoliObj.text = null;
      meseObj.text = null;
      spettacoliObj.dataBind();
      meseObj.dataBind();
      this.querySpettacoli = new Query().where("stagione", "equal", this.$refs.dropStagioni.ej2Instances.value);
      this.dropSpettacoliEnabled = true;
      this.dropMesiEnabled = false;
      this.elencoMesi = [];
      this.spettacoliMese = {};
      this.scrittureFullData = [];
      this.scrittureOriginalData = [];
      this.loading = false;
      this.$refs.gridA.$el.classList.add('disablegrid');
      document.getElementById("GridParent").classList.add('wrapper');
    },
    onMeseChange: function (e) {
      // devo aggiornare il contenuto della grid
      if (this.$refs.dropMese.ej2Instances.value) {
        // devo filtrare solo le scritture legate al mese selezionato
        this.scrittureFullData = this.scrittureOriginalData.filter((obj) => {
          if (obj) {
            if (this.spettacoliMese.hasOwnProperty(this.meseCorrente)) {
              const val = this.spettacoliMese[this.meseCorrente]
              return val.has(obj.id)
            }
          } else {
            console.log("errore oggetto")
            console.log(obj)
          }
          return false
        });
        // per ogni cedolino di ogni scrittura, prendo le informazioni del cedolino del mese corrente
        this.scrittureFullData.forEach((obj) => {
          if (obj.cedolini) {
            obj.cedolini.forEach((c) => {
              const data = new Date(c.mese)
              const m = data.getMonth() + 1
              if (m == this.meseCorrente) {
                obj.tipoCedolino = this.tipoCedolinoMap[c.tipologia]
                obj.statoCedolini = 'generato'
                obj.nota = c.nota
                this.cedolinoActiveData = c
                obj.cedolinoId = c.id
                return
              }
            })
          }
        })
        this.scrittureFullData = [ ...this.scrittureFullData ]
        console.log("SCRITTURE da visualizzare")
        console.log(this.scrittureFullData)

        // abilito gridA
        this.$refs.gridA.$el.classList.remove('disablegrid');
        document.getElementById("GridParent").classList.remove('wrapper');
      }
    },
    onSpettacoloChange: function (e) {
      // Inserire la chiamata per popolare la gridA e aggiornare il titolo di "Elenco Cedolini" e sottotitolo
      this.loading = true
      console.log("Recupero elenco cedolini dal backend");
      const datiDaInviare = {
        spettacolo: this.spettacoloCorrente,
      };
      if (datiDaInviare.spettacolo === null) {
        console.log("Spettacolo non ancora selezionato");
      } else {
        var meseObj = document.getElementById('dropMese').ej2_instances[0];
        meseObj.text = null;
        meseObj.dataBind();
        this.spettacoliMese = {};
        this.elencoMesi = [];
        this.scrittureFullData = [];
        this.scrittureOriginalData = [];

        useJwt.post(apiScritturaRicercaUrl, datiDaInviare).then((d) => {
          // prendo solo le scritture con stato confermato e che non appartengono alla tipologia 1 o 2
          this.scrittureOriginalData = d.data.filter((obj) => {
            return (["confermato", "validato"].includes(obj.stato) && !['1', '2'].includes(obj.tipologia));
          });
          // console.log("Elenco scritture collegate");
          // console.log(this.scrittureOriginalData);
          this.loading = false;
          // creo l'elenco dei mesi coinvolti nelle scritture
          // trova data minore e data maggiore
          // poi inserisci tutti i mesi appartenenti all'intervallo
          let min = 12
          let max = 1
          this.scrittureOriginalData.forEach((obj) => {
            min = this.dataMinMax(obj.intervallo1_inizio, min, 'min')
            max = this.dataMinMax(obj.intervallo1_fine, max, 'max')
            max = this.dataMinMax(obj.intervallo2_fine, max, 'max')
            max = this.dataMinMax(obj.intervallo3_fine, max, 'max')
            // mappa spettacoli su mesi
            this.mappaSpettacoloMese(obj.intervallo1_inizio, obj.id, this.spettacoliMese)
            this.mappaSpettacoloMese(obj.intervallo1_fine, obj.id, this.spettacoliMese)
            this.mappaSpettacoloMese(obj.intervallo2_inizio, obj.id, this.spettacoliMese)
            this.mappaSpettacoloMese(obj.intervallo2_fine, obj.id, this.spettacoliMese)
            this.mappaSpettacoloMese(obj.intervallo3_inizio, obj.id, this.spettacoliMese)
            this.mappaSpettacoloMese(obj.intervallo3_fine, obj.id, this.spettacoliMese)
          })

          const mesiOrdinati = Object.keys(this.spettacoliMese).sort()
          // console.log(mesiOrdinati)
          const primoMese = mesiOrdinati[0]

          this.scrittureOriginalData.forEach((obj) => {
            //console.log("Scrittura")
            if((!obj.intervallo1_inizio)&&(!obj.intervallo1_fine)) {
              this.spettacoliMese[primoMese].add(obj.id)
              //console.log("Ciao")
              //console.log(obj.id)
            }
          })

          // console.log("mappa spettacoli mese")
          // console.log(this.spettacoliMese)
          this.elencoMesi = []
          for(var i = min; i <= max; i++) {
            this.elencoMesi.push({ label: this.dizionarioMesi[i], val: i.toString() })
          }
          // console.log(this.elencoMesi)
          this.dropMesiEnabled = true
        });
      }
    },
    // aggiorna onnumGiorniMeseRetribuitiChange
    onnumGiorniMeseRetribuitiChange: function () {
      // if (
      //   this.scrittureActiveData.tipologia == "3" ||
      //   this.scrittureActiveData.tipologia == "4"
      // ) {
      //   // Autonomi Tecnici/Artisti Compenso Giornaliero
      //   this.scrittureActiveData.compenso_totale =
      //     this.scrittureActiveData.compenso_lordo_giornaliero *
      //     this.scrittureActiveData.numGiorniScrittura;
      //   this.aggiornaCostoAziendaTotale();
      // } else if (
      //   this.scrittureActiveData.tipologia == "5" ||
      //   this.scrittureActiveData.tipologia == "6"
      // ) {
      //   // Autonomi Artisti Compenso Complessivo
      //   if (this.scrittureActiveData.numGiorniScrittura > 0) {
      //     this.scrittureActiveData.retribGiornaliera =
      //       this.scrittureActiveData.compenso_totale /
      //       this.scrittureActiveData.numGiorniScrittura;
      //     this.eseguiTestRetribuzioneGiornaliera();
      //   }
      // }
    },

    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true)
    },
    dialogA1Open(args) {
      this.dialogA1ErrorMsg = []
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogA1Close() {
      console.log('Chiusura dialogA1')
      this.dialogA1.tabAdialogA1Index = 0
    },
    dialogA1Ok() {
      console.log('Cliccato bottone OK di dialogA1')
      console.log(this.cedolinoActiveId)
      if (this.operazione !== 'show') {
        this.dialogA1ErrorMsg = []
        this.cedolinoActiveData['id_scrittura'] = this.scritturaActiveData.id
        this.cedolinoActiveData.meseCorrente = this.meseCorrente
        this.cedolinoActiveData.stagioneCorrente = this.stagioneCorrente
        // i campi numerici obbligatori lato backend possono arrivare a null dai
        // cedolini storici: garantisco un valore anche senza ricalcolo
        this.impostaDefaultNumerico(['imponibileRitenuta', 'imponibileIva', 'percIva', 'iva'])
        useJwt.post(apiCedolinoUrl, this.cedolinoActiveData)
          .then((d) => {
            this.cedolinoActiveId = d.data['id']
            this.scrittureFullData.forEach((obj) => {
              if (obj.id === this.scritturaActiveData.id) {
                obj.tipologia = d.data['tipologia']
                obj.tipoCedolino = this.tipoCedolinoMap[obj.tipologia]
                obj.statoCedolini = "OK"
                obj.nota = d.data['nota']
                obj.cedolinoId = this.cedolinoActiveId
              }
            })
            this.scrittureFullData = [...this.scrittureFullData]
            this.$refs.dialogA1.hide()
          })
          .catch((err) => {
            this.dialogA1ErrorMsg = this.estraiErroreBackend(err)
            // scroll in cima al dialog per rendere visibile l'alert
            this.$nextTick(() => {
              const el = document.getElementById('dialogA1')
              if (el) el.scrollTop = 0
            })
          })
      } else {
        this.$refs.dialogA1.hide()
      }
    },
    dialogA1Cancel() {
      console.log('Cliccato bottone Cancel di dialogA1')
      this.$refs.dialogA1.hide()
    },
    // per gridA
    gridAClickHandler(args) {
      try {
        const selectedRow = this.$refs.gridA.getSelectedRecords()
        this.scritturaActiveData = selectedRow[0]
        console.log("SCRITTURA SELEZIONATA")
        console.log(selectedRow[0])

        if(this.scritturaActiveData.cedolinoId) {
          this.cedolinoActiveId = this.scritturaActiveData.cedolinoId
          console.log(`Cedolino id: ${this.cedolinoActiveId}`)
          if (args.item.id === "delete") {
            const deleteUrl = `${apiCedolinoUrl}/${this.cedolinoActiveId}`;
            var tmp = this.scrittureFullData.find(
              (x) => x.id === this.scritturaActiveData.id
            );
            if (tmp) {
              console.log(tmp)
              tmp.tipoCedolino = null
              tmp.statoCedolini = null
              tmp.nota = null
              tmp.cedolinoId = null
            }
            tmp = this.scrittureOriginalData.find(
              (x) => x.id === this.scritturaActiveData.id
            );
            if (tmp) {
              console.log(tmp)
              tmp.tipoCedolino = null
              tmp.statoCedolini = null
              tmp.nota = null
              tmp.cedolinoId = null
            }
            this.scrittureFullData = [...this.scrittureFullData]
            this.scrittureOriginalData = [...this.scrittureOriginalData]

            useJwt.delete(deleteUrl).then((res) => {
              console.log("Eliminazione avvenuta con successo");
              // console.log(res.data)
            });
          } else {
            console.log(args.item.id)
            this.dialogA1.header = 'Rigenera cedolino esistente'
            this.operazione = 'edit'
            // 'edit' : modifica cedolino esistente
            console.log("ID cedolino: ", this.cedolinoActiveId)
            useJwt.get(apiCedolinoUrl + '/' + this.cedolinoActiveId).then((d) => {
              if (d.status != 200) {
                console.log("REDIRIGERE A LOGIN")
                alert("Effettua di nuovo il login")
              } else {
                console.log(d.data.data)
                this.cedolinoActiveData = d.data.data;
                this.cedolinoActiveData.mansione = this.scritturaActiveData.ruoloGenerale
                this.cedolinoActiveData.mese = this.meseCorrente
                this.cedolinoActiveData.dal = this.scritturaActiveData.intervallo1_inizio
                this.cedolinoActiveData.al = this.scritturaActiveData.intervallo1_fine
                this.$refs.aliquotaIva.ej2Instances.value = this.cedolinoActiveData.aliquotaIva
                this.$refs.aliquotaIva.dataBind();
                this.$refs.tipologia.ej2Instances.value = Number(this.cedolinoActiveData.tipologia)
                this.$refs.tipologia.ej2Instances.refresh()

                this.gestioneGiorniMese()

                if (args.item.id === 'download') {
                  this.downloadCedolino(this.cedolinoActiveData.fileDocumento);
                }
                if (args.item.id === 'downloadPDF') {
                  this.downloadCedolino(this.cedolinoActiveData.filePdf);
                }
              }
            });
          }
        } else {
          if ((args.item.id === 'download')|| (args.item.id === 'downloadPDF')){
            this.makeToast('primary', 'Attenzione', 'Selezionata scrittura senza cedolino')
          } else {
            // creazione nuovo cedolino
            this.operazione = 'new'
            console.log("FINISCO QUI in caso di cedolino mai generato")
            this.cedolinoActiveData = {
              nota: "",
              tipologia: null,
              mese: this.meseCorrente,
              // campi obbligatori lato backend: valorizzati a 0 nel caso il
              // cedolino venga salvato senza premere "Calcola il cedolino"
              imponibileRitenuta: 0,
              imponibileIva: 0,
              percIva: 0,
              iva: 0,
            }
            // fill info cedolino (da fare comunque)
            this.cedolinoActiveData.mansione = this.scritturaActiveData.ruoloGenerale
            // TODO: retrib giornaliera , compenso totale, categoriaInps vanno sovrascritti se eiste gia' valore in cedolino
            this.cedolinoActiveData.retribGiornaliera = this.scritturaActiveData.retribGiornaliera
            this.cedolinoActiveData.compensoTotale = this.scritturaActiveData.compenso_totale
            this.cedolinoActiveData.categoriaInps = this.scritturaActiveData.categoriaInps
            // aggiunta Simo 19/10
            this.cedolinoActiveData.numGiorniScritturaTotali = this.scritturaActiveData.numGiorniScrittura
            this.gestioneGiorniMese()
            // se tipologia non e' diritti
            this.cedolinoActiveData.categoriaEnpals = this.scritturaActiveData.tipologia_contributo_soggetto
            // regimeFiscale
            this.cedolinoActiveData.regimeFiscale = this.scritturaActiveData.regimeFiscale

            // preselect aliquotaIva
            this.cedolinoActiveData.aliquotaIva = "10"
            this.$refs.aliquotaIva.ej2Instances.value = this.cedolinoActiveData.aliquotaIva
            this.$refs.aliquotaIva.dataBind();

            // fix tipologia
            if (this.scritturaActiveData.ruoloGenerale.includes("Diritti")) {
              this.cedolinoActiveData.tipologia = '2'
              this.cedolinoActiveData.dal = null;
              this.cedolinoActiveData.al = null;
              this.$refs.dpDal.ej2Instances.value = null;
              this.$refs.dpDal.ej2Instances.refresh()
              this.$refs.dpAl.ej2Instances.value = null;
              this.$refs.dpAl.ej2Instances.refresh()
            } else {
              this.cedolinoActiveData.tipologia = '1'
              this.cedolinoActiveData.dal = this.scritturaActiveData.intervallo1_inizio
              this.cedolinoActiveData.al = this.scritturaActiveData.intervallo1_fine
            }
            this.$refs.tipologia.ej2Instances.value = this.cedolinoActiveData.tipologia
            this.$refs.tipologia.dataBind();
          }
        } // fine gestione edit/create

        if (args.item.id === 'show') {
          this.operazione = 'show'
          this.showDownload = true
          console.log('Premuto tasto SHOW cedolino da gridA')
        }

        useJwt.get(apiSoggettiUrl + '/' + this.scritturaActiveData.soggetto).then((d) => {
          if (d.status != 200) {
            console.log("REDIRIGERE A LOGIN")
            alert("Effettua di nuovo il login")
          } else {
            // console.log("soggetto");
            // console.log(d.data);
            this.soggettoActiveData = d.data
            // commentato, ora lo prende da scrittura
            // this.cedolinoActiveData.regimeFiscale = this.soggettoActiveData.regimeFiscale
            // this.$refs.regimeFiscale.ej2Instances.value = this.soggettoActiveData.regimeFiscale
            // this.$refs.regimeFiscale.dataBind();
          }
        });
        if ((args.item.id !== 'download')&&(args.item.id !== 'delete')&&(args.item.id !== 'downloadPDF')) {
          this.$refs.dialogA1.show(true)
        }
      } catch (err) {
        console.log('Occorre selezionare una riga della tabella')
        this.makeToast('primary', 'Attenzione', 'Occorre selezionare una riga della tabella')
      }
    },

    // per download 
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create();
      uninterceptedAxiosInstance
        .get(url, {
          responseType: "arraybuffer",
          crossdomain: true,
        })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    downloadCedolino(cedolinoUrl) {
      console.log("Cliccato bottone Download Cedolino");

      const nomeFile = cedolinoUrl.split("\\")
        .pop()
        .split("/")
        .pop()
        .split("?")[0];
      this.downloadFile(cedolinoUrl, nomeFile);
    },
    calcolaCedolino() {
      console.log("Calcola Cedolino");
      // tipologia 1 (cedolino ordinario)
      if (this.cedolinoActiveData.tipologia == "1") {
        console.log("Cedolino Ordinario: ordinario")
        // calcolo il compenso
        this.cedolinoActiveData.compenso = this.roundNumber(this.cedolinoActiveData.compensoTotale * (this.cedolinoActiveData.numGiorniMeseRetribuiti / this.cedolinoActiveData.numGiorniScritturaTotali))
        //this.cedolinoActiveData.compenso = this.cedolinoActiveData.retribGiornaliera * this.cedolinoActiveData.numGiorniMeseRetribuiti
        // calcolo la ritenuta d'acconto
        this.cedolinoActiveData.imponibileRitenuta = this.cedolinoActiveData.compenso
        console.log(this.cedolinoActiveData.regimeFiscale)
        if (this.cedolinoActiveData.regimeFiscale == "ordinario") {
          this.cedolinoActiveData.ritenutaAcconto = this.roundNumber(this.cedolinoActiveData.imponibileRitenuta * 0.2)
          this.cedolinoActiveData.percRitenutaAcconto = 20
        }
        else if (this.cedolinoActiveData.regimeFiscale == "forfettario") {
          this.cedolinoActiveData.ritenutaAcconto = 0
          this.cedolinoActiveData.percRitenutaAcconto = 0
        }
        else if (this.cedolinoActiveData.regimeFiscale == "occasionale") {
          this.cedolinoActiveData.ritenutaAcconto = this.roundNumber(this.cedolinoActiveData.imponibileRitenuta * 0.2)
          this.cedolinoActiveData.percRitenutaAcconto = 20
        }
        else if (this.cedolinoActiveData.regimeFiscale == "straniero") {
          this.cedolinoActiveData.ritenutaAcconto = this.roundNumber(this.cedolinoActiveData.imponibileRitenuta * 0.3)
          this.cedolinoActiveData.percRitenutaAcconto = 30
        }
        // calcolo l'IVA
        // azzero prima di ricalcolare per non trascinare i valori di un calcolo
        // precedente (es. regime cambiato da ordinario a forfettario)
        this.cedolinoActiveData.percIva = 0
        this.cedolinoActiveData.iva = 0
        if (this.cedolinoActiveData.regimeFiscale == "ordinario") {
          this.cedolinoActiveData.imponibileIva = this.cedolinoActiveData.compenso //+ this.cedolinoActiveData.rimborsiSpese (da implementare)
          if (this.cedolinoActiveData.aliquotaIva == "22") {
            this.cedolinoActiveData.iva = this.roundNumber(this.cedolinoActiveData.imponibileIva * 0.22)
            this.cedolinoActiveData.percIva = 22
          }
          else if (this.cedolinoActiveData.aliquotaIva == "10") {
            this.cedolinoActiveData.iva = this.roundNumber(this.cedolinoActiveData.imponibileIva * 0.1)
            this.cedolinoActiveData.percIva = 10
          }
        }
        else {
          this.cedolinoActiveData.imponibileIva = 0
          this.cedolinoActiveData.aliquotaIva = ""
          this.cedolinoActiveData.iva = 0
        }
        
        // calcolo ENPALS
        // gestione "tabD"
        if (this.cedolinoActiveData.categoriaEnpals == "tabD") {
          // EnpalsCaricoDitta
          this.cedolinoActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) * 23.81 * 0.01)
          // EnpalsFPL, EnpalsContrSolid
          if (this.cedolinoActiveData.retribGiornaliera < 872.01) {
            this.cedolinoActiveData.percEnFPL = 9.19
            this.cedolinoActiveData.impEnpalsFPl = Math.round(this.cedolinoActiveData.compenso)
            this.cedolinoActiveData.EnpalsFPL = this.roundNumber(this.cedolinoActiveData.impEnpalsFPl * this.cedolinoActiveData.percEnFPL * 0.01)
          }
          else if (this.cedolinoActiveData.retribGiornaliera < 1744.01) {
            this.cedolinoActiveData.percEnFPL = 9.19
            this.cedolinoActiveData.percEnSol = 2.5
            this.cedolinoActiveData.impEnpalsFPl = this.roundNumber(this.cedolinoActiveData.numGiorniMeseRetribuiti * 872.00)
            this.cedolinoActiveData.EnpalsFPL = this.roundNumber(this.cedolinoActiveData.impEnpalsFPl * this.cedolinoActiveData.percEnFPL * 0.01)
            this.cedolinoActiveData.impEnpalsSolid = Math.round(this.cedolinoActiveData.compenso) - this.cedolinoActiveData.impEnpalsFPl
            this.cedolinoActiveData.EnpalsContrSolid = this.roundNumber(this.cedolinoActiveData.impEnpalsSolid * this.cedolinoActiveData.percEnSol * 0.01)
          }
          else if (this.cedolinoActiveData.retribGiornaliera < 4360.01) {
            this.cedolinoActiveData.percEnFPL = 9.19
            this.cedolinoActiveData.percEnSol = 2.5
            this.cedolinoActiveData.impEnpalsFPl = this.roundNumber(this.cedolinoActiveData.numGiorniMeseRetribuiti * 1744.00)
            this.cedolinoActiveData.EnpalsFPL = this.roundNumber(this.cedolinoActiveData.impEnpalsFPl * this.cedolinoActiveData.percEnFPL * 0.01)
            this.cedolinoActiveData.impEnpalsSolid = Math.round(this.cedolinoActiveData.compenso) - this.cedolinoActiveData.impEnpalsFPl
            this.cedolinoActiveData.EnpalsContrSolid = this.roundNumber(this.cedolinoActiveData.impEnpalsSolid * this.cedolinoActiveData.percEnSol * 0.01)
          }
          // EnpalsContrAgg
          if (this.cedolinoActiveData.retribGiornaliera > 176.00) {
            this.cedolinoActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) - this.cedolinoActiveData.numGiorniMeseRetribuiti * 176)
            this.cedolinoActiveData.percEnAgg = 1.0
            this.cedolinoActiveData.EnpalsContrAgg = this.roundNumber(this.cedolinoActiveData.impEnpalsAgg * this.cedolinoActiveData.percEnAgg * 0.01)
          }
          else {
            this.cedolinoActiveData.impEnpalsAgg = 0
            this.cedolinoActiveData.percEnAgg = 0
            this.cedolinoActiveData.EnpalsContrAgg = 0
          }
        }
        else if (this.cedolinoActiveData.categoriaEnpals == "tabC") {
          // EnpalsCaricoDitta
          this.cedolinoActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) * 23.81 * 0.01)
          // EnpalsFPL, EnpalsContrSolid
          this.cedolinoActiveData.percEnFPL = 9.19
          this.cedolinoActiveData.impEnpalsFPl = Math.round(this.cedolinoActiveData.compenso)
          this.cedolinoActiveData.EnpalsFPL = this.roundNumber(this.cedolinoActiveData.impEnpalsFPl * this.cedolinoActiveData.percEnFPL * 0.01)
          this.cedolinoActiveData.impEnpalsSolid = 0
          this.cedolinoActiveData.percEnSol = 0
          this.cedolinoActiveData.EnpalsContrSolid = 0;
          // EnpalsContrAgg
          if (Math.round(this.cedolinoActiveData.compenso) > (55448.00 / 12.00)) {
            this.cedolinoActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) - (55448.00/12.00))
            this.cedolinoActiveData.percEnAgg = 1.0
            this.cedolinoActiveData.EnpalsContrAgg = this.roundNumber(this.cedolinoActiveData.impEnpalsAgg * this.cedolinoActiveData.percEnAgg * 0.01)
          }
          else {
            this.cedolinoActiveData.impEnpalsAgg = 0
            this.cedolinoActiveData.percEnAgg = 0
            this.cedolinoActiveData.EnpalsContrAgg = 0
          }
        }
        else if (this.cedolinoActiveData.categoriaEnpals == "tabG") {
          // EnpalsCaricoDitta
          this.cedolinoActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) * 23.81 * 0.01)
          // EnpalsFPL, EnpalsContrSolid
          this.cedolinoActiveData.percEnFPL = 9.19
          this.cedolinoActiveData.impEnpalsFPl = Math.round(this.cedolinoActiveData.compenso)
          this.cedolinoActiveData.EnpalsFPL = this.roundNumber(this.cedolinoActiveData.impEnpalsFPl * this.cedolinoActiveData.percEnFPL * 0.01)
          this.cedolinoActiveData.impEnpalsSolid = 0
          this.cedolinoActiveData.percEnSol = 0
          this.cedolinoActiveData.EnpalsContrSolid = 0;
          // EnpalsContrAgg
          if (Math.round(this.cedolinoActiveData.compenso) > (55448.00 / 12.00)) {
            this.cedolinoActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) - (55448.00/12.00))
            this.cedolinoActiveData.percEnAgg = 1.0
            this.cedolinoActiveData.EnpalsContrAgg = this.roundNumber(this.cedolinoActiveData.impEnpalsAgg * this.cedolinoActiveData.percEnAgg * 0.01)
          }
          else {
            this.cedolinoActiveData.impEnpalsAgg = 0
            this.cedolinoActiveData.percEnAgg = 0
            this.cedolinoActiveData.EnpalsContrAgg = 0
          }
        }
        else if (this.cedolinoActiveData.categoriaEnpals == "tabR") {
          // EnpalsCaricoDitta
          this.cedolinoActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) * 25.81 * 0.01)
          // EnpalsFPL, EnpalsContrSolid
          this.cedolinoActiveData.percEnFPL = 9.89
          this.cedolinoActiveData.impEnpalsFPl = Math.round(this.cedolinoActiveData.compenso)
          this.cedolinoActiveData.EnpalsFPL = this.roundNumber(this.cedolinoActiveData.impEnpalsFPl * this.cedolinoActiveData.percEnFPL * 0.01)
          this.cedolinoActiveData.impEnpalsSolid = 0
          this.cedolinoActiveData.percEnSol = 0
          this.cedolinoActiveData.EnpalsContrSolid = 0;
          // EnpalsContrAgg
          if (Math.round(this.cedolinoActiveData.compenso) > (55448.00 / 12.00)) {
            this.cedolinoActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) - (55448.00/12.00))
            this.cedolinoActiveData.percEnAgg = 1.0
            this.cedolinoActiveData.EnpalsContrAgg = this.roundNumber(this.cedolinoActiveData.impEnpalsAgg * this.cedolinoActiveData.percEnAgg * 0.01)
          }
          else {
            this.cedolinoActiveData.impEnpalsAgg = 0
            this.cedolinoActiveData.percEnAgg = 0
            this.cedolinoActiveData.EnpalsContrAgg = 0
          }
        }

      }
      // tipologia 2 (cedolino scrittura)
      else if (this.cedolinoActiveData.tipologia == "2") {
        console.log("Cedolino Diritti: diritti")
        // calcolo il compenso
        this.cedolinoActiveData.compenso = this.cedolinoActiveData.compensoTotale
        // calcolo la ritenuta d'acconto
        this.cedolinoActiveData.imponibileRitenuta = this.roundNumber(Math.round(this.cedolinoActiveData.compenso) * 0.75)
        if (this.cedolinoActiveData.regimeFiscale == "ordinario") {
          this.cedolinoActiveData.percRitenutaAcconto = 20
        }
        else if (this.cedolinoActiveData.regimeFiscale == "forfettario") {
          this.cedolinoActiveData.percRitenutaAcconto = 20
        }
        else if (this.cedolinoActiveData.regimeFiscale == "occasionale") {
          this.cedolinoActiveData.percRitenutaAcconto = 20
        }
        else if (this.cedolinoActiveData.regimeFiscale == "straniero") {
          this.cedolinoActiveData.percRitenutaAcconto = 30
        }
        this.cedolinoActiveData.ritenutaAcconto = this.roundNumber(this.cedolinoActiveData.imponibileRitenuta  * this.cedolinoActiveData.percRitenutaAcconto * 0.01)
        // calcolo IVA
        this.cedolinoActiveData.imponibileIva = 0 // da arricchire
        this.cedolinoActiveData.percIva = 0
        if (this.cedolinoActiveData.aliquotaIva == "22") { this.cedolinoActiveData.iva = 0 }
        else if (this.cedolinoActiveData.aliquotaIva == "10") { this.cedolinoActiveData.iva = 0 }
        this.cedolinoActiveData.EnpalsCaricoDitta = 0
        this.cedolinoActiveData.percEnFPL = 0
        this.cedolinoActiveData.impEnpalsFPl = 0
        this.cedolinoActiveData.EnpalsFPL = 0
        this.cedolinoActiveData.impEnpalsSolid = 0
        this.cedolinoActiveData.percEnSol = 0
        this.cedolinoActiveData.EnpalsContrSolid = 0;
        this.cedolinoActiveData.impEnpalsAgg = 0
        this.cedolinoActiveData.percEnAgg = 0
        this.cedolinoActiveData.EnpalsContrAgg = 0
        

      }
      
      console.log(this.cedolinoActiveData);
    },

    estraiErroreBackend(err) {
      const data = err?.response?.data
      if (!data) return ['Errore di comunicazione con il server']
      if (typeof data === 'string') return [data]
      if (data.detail) return [data.detail]
      return Object.entries(data)
        .map(([campo, errori]) => `${campo}: ${Array.isArray(errori) ? errori.join(', ') : errori}`)
    },
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    noop() {
      console.log("premuto enter")
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
